import { ErrorMessage } from "@hookform/error-message";
import { Controller, useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { Button, Input, Table } from "reactstrap";
import { RSelect } from "../../../components/Component";
import { useMemo } from "react";
export const CommissionComponent = ({
  customerOptions = [],
  name = 'commissions'
}) => {
  const { errors, control, getValues } = useFormContext();
  const {
    fields: commissions,
    remove: removeBillCommissions,
    append: appendBillCommissions,
  } = useFieldArray({
    control,
    name,
  })

  const fieldWatch = useWatch({
    control,
    name,
    defaultValue: [],
  });

  const customerIds = useMemo(() => {
    return fieldWatch.map((commission) => commission?.customerId).filter(Boolean);
  }, [fieldWatch]);
  return (
    <Table className="table table-bordered">
      <thead>
        <tr>
          <th>Khách hàng</th>
          <th>Phí hoa hồng/kg</th>
          <th>Mô tả</th>
          <th>
            <Button
              color="primary"
              className="btn-sm"
              onClick={() => appendBillCommissions({
                customerId: null,
                commissionFeePerWeight: null,
              })}
            >
              Thêm
            </Button>
          </th>
        </tr>
      </thead>
      <tbody>
        {commissions.map((commission, index) => (
          <tr key={index}>
            <td>
              <Controller
                defaultValue={commission?.customerId}
                control={control}
                name={`${name}.${index}.customerId`}
                rules={{
                  required: "Vui lòng nhập thông tin",
                }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    ref={ref}
                    name={name}
                    options={customerOptions}
                    isOptionDisabled={(option) => customerIds.includes(option.value)}
                    value={
                      customerOptions.find((c) => c.value === value) || null
                    }
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={`${name}.${index}.customerId`}
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </td>
            <td>
              <Controller
                control={control}
                name={`${name}.${index}.commissionFeePerWeight`}
                rules={{ required: "Vui lòng nhập thông tin" }}
                defaultValue={commission?.commissionFeePerWeight}
                render={({ onChange, value, ref }) => (
                  <NumericFormat
                    className="form-control"
                    getInputRef={ref}
                    type="text"
                    value={value}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={0}
                    onValueChange={(val) => onChange(val.floatValue)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={`${name}.${index}.commissionFeePerWeight`}
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </td>
            <td>
              <Controller
                control={control}
                name={`${name}.${index}.description`}
                defaultValue={commission?.description}
                render={({ onChange, value }) => (
                  <Input type="text" value={value} onChange={(e) => onChange(e.target.value)} />
                )}
              />
            </td>
            <td>
              <Button
                color="danger"
                className="btn-sm"
                onClick={() => removeBillCommissions(index)}
              >
                Xóa
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};